import React from 'react';
import classNames from 'classnames';
import Nav from './Nav';
import * as S from './styles';
/**
 * @public
 */

/**
 * @public
 */
var AppLayout = function AppLayout(_ref) {
  var nav = _ref.nav,
      navCollapsible = _ref.navCollapsible,
      navCollapsed = _ref.navCollapsed,
      defaultNavCollapsed = _ref.defaultNavCollapsed,
      onNavCollapseTriggerClick = _ref.onNavCollapseTriggerClick,
      _ref$adjustHeight = _ref.adjustHeight,
      adjustHeight = _ref$adjustHeight === void 0 ? 'consoleBaseTopbarRoot' : _ref$adjustHeight,
      children = _ref.children,
      className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/React.createElement(S.AppLayout, {
    adjustHeight: adjustHeight,
    className: classNames('wind-rc-app-layout', 'windcc-app-layout', className),
    style: style
  }, nav && /*#__PURE__*/React.createElement(Nav, {
    collapsible: navCollapsible,
    collapsed: navCollapsed,
    defaultCollapsed: defaultNavCollapsed,
    onCollapseTriggerClick: onNavCollapseTriggerClick
  }, nav), /*#__PURE__*/React.createElement(S.Content, {
    className: "windcc-app-layout__content"
  }, children));
};

export default AppLayout;